export const SSO_ENABLED = 'sso_enabled';
export const INTEGRATIONS_ENABLED = 'integrations_enabled';
export const CHARGEBEE_ENABLED = 'chargebee_enabled';
export const ANALYTICS_ENABLED = 'analytics_enabled';
export const ONBOARDING_ENABLED = 'onboarding_enabled';
export const AI_TEMPLATE_ENABLED = 'ai_template_enabled';
export const ENTITIES_UPLOAD_ENABLED = 'entities_upload_enabled';
export const ENTITY_TYPE_OF_RESPONSE_ENABLED = 'entity_type_of_response_enabled';
export const SESSION_LIMITATION_ENABLED = 'session_limitation_enabled';
export const AVERAGE_WEIGHTED_SCORE_CALCULATION_ENABLED = 'average_weighted_score_calculation_enabled';
export const TBR_ENABLED = 'tbr_enabled';
export const FILE_TYPE_OF_RESPONSE_ENABLED = 'file_type_of_response_enabled';
export const DISABLE_FREE_PLAN_ENABLED = 'disable_free_plan_enabled';
export const APPROVALS_ENABLED = 'approvals_enabled';
export const DISCOUNT_FOR_CHURNS_ENABLED = 'discount_for_churns_enabled';
export const REPORT_VIEW_RESTRICTIONS_ENABLED = 'report_view_restrictions_enabled';
export const ROCC_SCORING_ENABLED = 'rocc_scoring_enabled';
export const FORM_TRANSLATIONS_ENABLED = 'form_translations_enabled';
export const MANUAL_FORM_TRANSLATIONS_ENABLED = 'manual_form_translations_enabled';
export const RTE_ENABLED = 'rte_enabled';
export const AI_PRICING_ENABLED = 'ai_pricing_enabled';
export const AI_CHAT_ENABLED = 'ai_chat_enabled';
export const ENTITY_PROPERTIES_ENABLED = 'entity_properties_enabled';
export const ENTITY_PROPERTY_PREFILL_ENABLED = 'entity_property_prefill_enabled';
export const AI_IMAGE_DESCRIPTION_ENABLED = 'ai_image_description_enabled';
export const AI_PACK_ENABLED = 'ai_pack_enabled';
export const LAST_LOGIN_ENABLED = 'last_login_enabled';
export const WORD_TEMPLATE_REPORT_ENABLED = 'word_template_report_enabled';
export const AI_BLUR_FACES_ENABLED = 'ai_blur_faces_enabled';
export const AI_IMAGE_VALIDATION_ENABLED = 'ai_image_validation_enabled';
export const AI_IMPROVE_WRITING_ENABLED = 'ai_improve_writing_enabled';
